export default "__VITE_ASSET__BDlIvS9I__"